import Image from 'next/image';
import Link from 'next/link';

import { routes } from '../constants/routes';

const currentYear = new Date().getFullYear();

export default function LoginRequiredPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="mt-auto flex flex-1 items-center justify-center">
        <div className="flex flex-col items-center">
          <div className="mb-16 flex">
            <Image
              alt="logo"
              height={83}
              src="/images/logo-with-text.svg"
              width={238}
            />
          </div>
          <Image
            alt="lesson-planner-maintenance"
            height={250}
            src="/images/maintenance.svg"
            width={367}
          />

          <div className="mt-5 mb-5 text-center text-4xl font-bold text-[#212121] sm:text-[44px]">
            Login Required!
          </div>
          <div className="p-5 text-center text-lg text-[#6A7280] sm:text-xl">
            You need to login to access this page.
          </div>
        </div>
      </div>
      <div className="mt-auto flex w-full flex-col-reverse items-center py-2 text-slate-600 sm:flex-row sm:justify-between sm:py-4 sm:px-20 md:px-10 lg:py-4 lg:px-20">
        <p>© Lesson Planner {currentYear}</p>

        <div className="flex">
          <Link
            className="hover:underline"
            href={routes.TERMS_AND_CONDITIONS}
            target="_blank"
          >
            Terms & Conditions
          </Link>
          <p className="mx-2">•</p>
          <Link
            className="hover:underline"
            href={routes.PRIVACY_POLICY}
            target="_blank"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
}
